import React from 'react'

import { useSpecsContext } from '@/screens/Product/api/SpecsContext'

import { scrollToTabSection } from '@/shared/lib/utils/scroll/scrollToTabSection'
import { TSelectedProductProps } from '@/shared/types/product-types'
import { Button } from '@/shared/ui'

import { ProductSpecs } from './components/ProductSpecs/ProductSpecs'

import cl from './product-specs-panel.module.scss'

type ProductSpecsPanelProps = {
	items: TSelectedProductProps[]
}

const TABS_ID_ATTR = `productTabs`

export const ProductSpecsPanel = ({ items }: ProductSpecsPanelProps): JSX.Element => {
	const { expandSpecs } = useSpecsContext()

	const onClick = () => {
		expandSpecs()
		scrollToTabSection(TABS_ID_ATTR, `tab-pane-specs`)
	}

	const displayItems = items.slice(0, 4)

	return (
		<div className={cl.productSpecsPanel}>
			<ProductSpecs items={displayItems} />
			<Button theme="link" onClick={onClick}>
				Все характеристики
			</Button>
		</div>
	)
}
